var path = 'app/scripts/modules/cloudfoundry/serverGroup/configure/serverGroupLoadBalancersDirective.html';
var html = "<ng-form name=\"loadBalancers\">\n  <div class=\"form-group\">\n    <div class=\"col-md-3 sm-label-right\">\n      <b>Load Balancers</b>\n    </div>\n    <div class=\"col-md-7\">\n      <input type=\"text\"\n             class=\"form-control input-sm\"\n             name=\"repository\"\n             ng-model=\"command.loadBalancers\"/>\n    </div>\n  </div>\n</ng-form>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/cloudfoundry/serverGroup/configure/serverGroupLoadBalancersDirective.html
// module id = 1647
// module chunks = 0